// filepath: src/components/category-chip/styles.ts
import styled from "styled-components";
import { Chip } from "@mui/material";
import theme from "../../../../styles/theme";

export const StyledChip = styled(Chip)<{
  $selected: boolean;
  selectionType?: "primary" | "secondary";
}>`
  && {
    font-family: var(--font-sans);
    font-weight: 500;
    font-size: 14px;
    border-radius: 20px;
    padding: 18px 12px;
    height: 40px;
    min-width: 150px;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    border: 1px solid transparent;
    cursor: pointer;

    ${({ $selected, selectionType }) => {
      if (!$selected) {
        return `
          background-color: #f1f3f4;
          color: #2B2D31;
          &:hover {
            background-color: #E2E6EA;
            border-color: #D6E4F7;
          }
        `;
      }
      if (selectionType === "primary") {
        return `
          background-color: ${theme.colors.blue.primary};
          color: white;
          &:hover {
            background-color: #3367D6;
          }
        `;
      }
      return `
        background-color: #1E8E3E; // Verde Google
        color: white;
        &:hover {
          background-color: #2c8f45; // Verde mais escuro
        }
      `;
    }}

    &.Mui-disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;